var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":"formFile"}},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","name":"fileName","value":"啊啊啊啊","id":"fileName"},on:{"change":_vm.upFile}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",staticStyle:{"display":"inline"},attrs:{"for":"fileName"}},[_vm._v("选择文件")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4c2509a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/upload/upload.vue
// module id = null
// module chunks = 